export default __webpack_public_path__ + "static/media/SOBH Lobby.52d677b1.jpg";